export const CHAT_SCROLL_BOTTOM_TOLERANCE = 48;

type ScrollContainer = Pick<HTMLElement, 'clientHeight' | 'scrollHeight' | 'scrollTop'>;

/**
 * Browser scroll dimensions may settle a few pixels apart after rich media
 * loads. Keep the conversation at its visual end inside that small margin.
 */
export function isNearScrollBottom(
  { clientHeight, scrollHeight, scrollTop }: ScrollContainer,
  tolerance = CHAT_SCROLL_BOTTOM_TOLERANCE,
) {
  return scrollHeight - scrollTop - clientHeight <= tolerance;
}
